import ensureSegmentAnalytics from './ensureSegmentAnalytics';
import formatDataLayerToSegment from './helpers/formatDataLayer';
async function sendSegmentEvent(callback, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    disableSegment = false
  } = options;
  if (!disableSegment) {
    const segment = await ensureSegmentAnalytics(options);
    callback(segment);
  }
}
export async function sendPageEvent(metadata, options) {
  if (metadata === void 0) {
    metadata = {};
  }
  if (options === void 0) {
    options = {};
  }
  await sendSegmentEvent(async segment => {
    await segment?.page?.({
      path: metadata.history?.location?.pathname,
      search: metadata.history?.location?.search
    });
  }, options);
  const segmentData = formatDataLayerToSegment(metadata);
  await sendSegmentEvent(segment => {
    segment.track(segmentData.eventName, segmentData.data);
  }, options);
}
export async function sendClickEvent(eventName, data, options) {
  if (data === void 0) {
    data = {};
  }
  if (options === void 0) {
    options = {};
  }
  await sendSegmentEvent(segment => {
    segment.track(eventName, data);
  }, options);
}
export async function sendIdentifyEvent(userId, data, options) {
  if (data === void 0) {
    data = {};
  }
  if (options === void 0) {
    options = {};
  }
  await sendSegmentEvent(segment => {
    segment?.identify?.(userId, data);
  }, options);
}
export async function sendResetEvent(options) {
  if (options === void 0) {
    options = {};
  }
  await sendSegmentEvent(segment => {
    segment.reset();
  }, options);
}